import {cloneElement} from 'react'
import {css} from '@emotion/react'
import {CheckOutlined} from '@ant-design/icons'
import {useOpenModal} from '@/components/Modal/index.mjs'
import {DraftIconButton, useAiContext} from '../core'
import useParseAiOutput from './useParseAiOutput.jsx'

const cssButton = css({
    '&.ant-btn-primary': {
        backgroundColor: '#00b578 !important',

        '&:not([disabled]):hover': {
            backgroundColor: '#00a467 !important',
        }
    }
})

export const ButtonImportModel = ({disabled, ...props}) => {
    const ai = useAiContext()
    const _disabled = disabled || 'done' !== ai.getLastMessage()?.status

    return (
        <DraftIconButton
            css={cssButton}
            disabled={_disabled}
            title="导入模型"
            type="primary"
            {...props}
        >
            <CheckOutlined />
        </DraftIconButton>
    )
}

export const _ButtonImportModel = ({modal, ...props}) => {
    const openModal = useOpenModal()
    const ai = useAiContext()
    const parseAiOutput = useParseAiOutput(ai)

    const onClick = async () => {
        const {pkid: prjId, prjName, prjNo, sVer} = ai.project
        const files = await parseAiOutput()
        const fileIds = files.map(e => e.fileId)
        const {apiMarkMethod} = ai.template

        openModal(
            cloneElement(modal, {
                apiMarkMethod,
                fileIds,
                prjId,
                prjName,
                prjNo,
                sVer,
            })
        )
    }

    return (
        <ButtonImportModel
            onClick={onClick}
            {...props}
        />
    )
}
